// SPDX-License-Identifier: Apache-2.0

import React, { useContext, useState } from "react";
import { Container, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AppContext } from "../AppContext";
import LPPositions from "./forms/LPPositions";
import LPDepositForm from "./forms/LPDepositForm";
import LPWithdrawForm from "./forms/LPWithdrawForm";

const TABS = ["positions", "deposit", "withdraw"] as const;
type Tab = (typeof TABS)[number];

// LP dashboard: view positions, deposit, withdraw (CKB + ETH). Mirrors
// SwapScreen's container styling.
function LiquidityScreen() {
  const { t } = useTranslation();
  const ctx = useContext(AppContext);
  const [tab, setTab] = useState<Tab>("positions");

  const hasWallet = Boolean(
    ctx.client?.ethAddress || ctx.client?.nervosAddress,
  );

  return (
    <Container className="SwapContainer mt-2 w-75">
      <h3>{t("liquidityPool")}</h3>
      <hr className="title-divider" />

      {!hasWallet ? (
        <p>{t("lpConnectWallet")}</p>
      ) : (
        <>
          <Nav
            variant="tabs"
            activeKey={tab}
            className="mb-3"
            onSelect={(k) => k && setTab(k as Tab)}
          >
            <Nav.Item>
              <Nav.Link eventKey="positions">{t("lpPositions")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="deposit">{t("lpDeposit")}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="withdraw">{t("lpWithdraw")}</Nav.Link>
            </Nav.Item>
          </Nav>

          <div className="d-flex h-100 flex-column align-items-start">
            {tab === "positions" && <LPPositions />}
            {tab === "deposit" && <LPDepositForm />}
            {tab === "withdraw" && <LPWithdrawForm />}
          </div>
        </>
      )}
    </Container>
  );
}

export default LiquidityScreen;
